<template>
    <div class="banner">
        <div class="title3" v-if="filter"><span class="helvetica">Position Papers on {{ title }}</span> →</div>
        <div class="title3" v-else><span class="helvetica">Position Papers</span> →</div>
        <div v-if="data?.papers" class="thumbnails-container">
            <div class="paper" v-for="paper in data?.papers">
                <div class="filler"></div>
                <Image :image="paper.cover" :height="100" :width="100" :mobileWidth="500" :mobileHeight="500" imageClass="cover" />
            </div>
        </div>
        <NuxtLink class="overlink" :to="{ name: 'publications-position-papers', query: filter ? { theme: filter } : undefined }"></NuxtLink>
    </div>
</template>

<script setup lang="ts">
const { getPositionPapersBanner } = usePublications();
const { data } = useLazyAsyncData(() => getPositionPapersBanner());
defineProps<{ filter?: string; title?: string }>()
</script>

<style lang="scss" scoped>
.banner {
    position: relative;

    margin: var(--size-gutter-sections) var(--size-margin-page) 0 var(--size-margin-page);
    background-color: #B3D8E0;
    color: var(--color-primary);

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--size-margin-page);
    padding: var(--size-gutter-default);

    .thumbnails-container {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: var(--size-gutter-small);

        .paper {
            position: relative;

            .filler {
                padding-top: 100%;
            }

            &:deep(.responsivePicture) {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;

                //mix-blend-mode: multiply;
            }
        }

    }
}

@media screen and (max-width: 600px) {
    .banner {
        display: flex;
        flex-direction: column;


        .title3 {
            order: 2;
        }

        .thumbnails-container {
            order: 1;

            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-gutter-default);

            .paper {

                &:last-of-type {
                    display: none;
                }
            }
        }
    }
}
</style>